<template>
  <div>
    <!--  Small count (without hover nor participant list)  -->
    <div
      v-if="connected && (streamStatus === 'active' || virtual) && small"
      class="appo__participants-count appo__participants-count--small"
      @click="showConnectedList = !showConnectedList"
    >
      <div class="appo__participants-count-box">
        <div class="appo__participants-count-text">
          <base-icon
            v-if="appointment.is_host === true"
            icon="eye"
            style="padding-right: 3px"
          />
          <p style="margin-bottom: 0">
            {{
              appointment.is_host
                ? ` ${participants.length}`
                : appointment.presenter.replace(/\[.*\]/, '').trim()
            }}
          </p>
        </div>
      </div>
    </div>
    <!--  Normal count (with hover and participant list)  -->
    <base-hover
      v-if="!small"
      v-slot="{ isHover }"
    >
      {{ setBlurCorner(isHover) }}
      <div
        v-if="connected === true && (streamStatus === 'active' || virtual)"
        :class="isHover && appointment.is_host ? 'appo__participants-show' : 'appo__participants-count'"
      >
        <div class="appo__participants-count-box">
          <div class="appo__participants-count-text">
            <base-icon
              v-if="appointment.is_host === true"
              icon="eye"
              alt
              style="padding-right: 6px"
            />
            <p style="margin-bottom: 0">
              {{
                appointment.is_host
                  ? ` ${participants.length}`
                  : appointment.presenter.replace(/\[.*\]/, '').trim()
              }}
            </p>
          </div>
        </div>
        <div
          v-if="isHover && appointment.is_host"
          class="appo__participants_overflow"
        >
          <div
            v-for="part in participants"
            :key="part.sid"
            class="appo__participants-show-text"
          >
            <p class="participant_identity">
              {{ participantName(part) }}
            </p>
          </div>
        </div>
      </div>
    </base-hover>
  </div>
</template>

<script>
export default {
  name: 'ParticipantCount',
  props: {
    connected: {
      type: Boolean,
      default: false,
    },
    streamStatus: {
      type: String,
      default: 'idle',
    },
    appointment: {
      type: Object,
      default: null,
    },
    participants: {
      type: Array,
      default: () => [],
    },
    small: {
      type: Boolean,
      default: false,
    },
    virtual: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    setBlurCorner(event) {
      this.$emit('set-blur-corner', event);
    },
    participantName(participant) {
      return participant.name?.replace(/\[.*\]/, '').trim() || participant.identity?.replace(/\[.*\]/, '').trim();
    },
  },
};
</script>

<style lang="scss" scoped>
$breakpoint-1: 1024px;
.appo {

  &__participants_overflow {
    height: 186px;
    max-width: 100%;
    text-align: left;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 0;
  }
  &__participants-count-box {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  &__participants-count-text {
    font-family: 'Arial';
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 17px;
    min-width: 50px;
    margin: 5px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    align-self: center;
  }
  &__participants-show-text {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
  }
  &__participants-show {
    padding-top: 5px;
    padding-left: 12px;
    padding-right: 4px;
    background: transparent;
    border-radius: 8px;
    right: 0;
    top: 1rem;
    position: absolute;
    width: 220px;
    height: 260px;
    mask-image: linear-gradient(to bottom, black 60%, transparent 100%);

    ::-webkit-scrollbar {
      width: 4px;
      border-radius: 100px;
    }

    /* Track */
    // ::-webkit-scrollbar-track {
    // }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #faf9f7;
      border-radius: 100px;
      height: 20px;
    }
  }
  &__participants-count {
    background: rgba(51, 51, 51, 0.8);
    border-radius: 5px;
    position: absolute;
    margin: 0;
    // width: 60px;
    text-overflow: ellipsis;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0;
    display: none;
    &--small {
      position: static;
      display: inline-flex;
      margin-right: 0.5rem;
      width: inherit;
      // padding-left: 15px;
      // padding-right: 15px;
    }

    @media (min-width: $breakpoint-1) {
      bottom: inherit;
      left: inherit;
      right: 1rem;
      top: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
  }
.participant_identity {
  font-family: 'SilkaRegular';
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.9);

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 96%;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
  margin: 8px 0 0;
}
}
</style>
